"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsArray_1 = __importDefault(require("../typeAssertions/valueIsArray"));
const valueIsNullOrUndef_1 = __importDefault(require("../typeAssertions/valueIsNullOrUndef"));
const valueIsRecord_1 = __importDefault(require("../typeAssertions/valueIsRecord"));
const validateValueToInsertOnFirebase = (value) => {
    if (value === undefined) {
        return null;
    }
    if ((0, valueIsRecord_1.default)(value)) {
        return Object.entries(value).reduce((accum, [key, subValue]) => {
            const formattedSubValue = validateValueToInsertOnFirebase(subValue);
            if ((0, valueIsNullOrUndef_1.default)(formattedSubValue)) {
                return accum;
            }
            return Object.assign(Object.assign({}, accum), { [key]: subValue });
        }, {});
    }
    if ((0, valueIsArray_1.default)(value)) {
        return value
            .map((subValue) => validateValueToInsertOnFirebase(subValue))
            .filter((subValue) => !(0, valueIsNullOrUndef_1.default)(subValue));
    }
    return value;
};
const writeToDatabaseFunction = ({ database, }) => ({ updates, listener, shouldUpdateDbCache, projectId, setRenderDbCache, isDevelopment, }) => {
    Object.entries(updates).forEach(async ([key, value]) => {
        try {
            const dbName = isDevelopment ? 'dataDevelopment' : 'data';
            if ((0, valueIsRecord_1.default)(value)) {
                const athomic = Object.entries(value)
                    .reduce((athomicUpdates, [subValueKey, subValue]) => {
                    const formattedSubValue = validateValueToInsertOnFirebase(subValue);
                    if ((0, valueIsNullOrUndef_1.default)(formattedSubValue)) {
                        return athomicUpdates;
                    }
                    return Object.assign(Object.assign({}, athomicUpdates), { [`projects/${projectId}/${dbName}/${key}/${subValueKey}`]: formattedSubValue });
                }, {});
                await database.ref().update(athomic);
            }
            else if (!(0, valueIsNullOrUndef_1.default)(value)) {
                await database.ref(`projects/${projectId}/${dbName}/${key}`).set(validateValueToInsertOnFirebase(value));
            }
            if (shouldUpdateDbCache) {
                setRenderDbCache({
                    data: { val: () => value },
                    route: {
                        path: key,
                    },
                });
            }
            listener();
        }
        catch (error) {
            listener(`${error}`);
        }
    });
};
exports.default = writeToDatabaseFunction;
